import type { EventHomeLayout } from './eventHomeLayout.js';
import type { EventAppModules } from './eventModules.js';

export type EventBuilderAccess = 'invite_only' | 'public';

export interface EventBuilderRequirements {
  name: string | null;
  date_start: string | null;
  date_end: string | null;
  timezone: string | null;
  location: string | null;
  online: boolean | null;
  access: EventBuilderAccess | null;
}

export interface EventBuilderBlueprint {
  app_modules: EventAppModules;
  home_layout: EventHomeLayout;
}

export interface EventBuilderPreviewPayload {
  version: 1;
  revision: number;
  requirements: EventBuilderRequirements;
  blueprint: EventBuilderBlueprint;
}

export const EVENT_BUILDER_PREVIEW_MESSAGE = 'rubikoo:event-builder-preview';
export const EVENT_BUILDER_PREVIEW_READY_MESSAGE = 'rubikoo:event-builder-preview-ready';
